<svg
  width="24"
  height="20"
  viewBox="0 0 24 20"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  *ngIf="isFilled === true"
>
  <rect
    x="1"
    y="1"
    width="22"
    height="18"
    rx="4"
    stroke="currentColor"
    stroke-width="2"
  />
  <rect x="1" y="1" width="7.66667" height="18" rx="4" fill="currentColor" />
  <line
    x1="8.66667"
    y1="1"
    x2="8.66667"
    y2="19"
    stroke="currentColor"
    stroke-width="2"
  />
</svg>

<svg
  width="24"
  height="20"
  viewBox="0 0 24 20"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  *ngIf="isFilled === false"
>
  <rect
    x="1"
    y="1"
    width="22"
    height="18"
    rx="4"
    stroke="currentColor"
    stroke-width="2"
  />
  <line
    x1="8.66667"
    y1="1"
    x2="8.66667"
    y2="19"
    stroke="currentColor"
    stroke-width="2"
  />
</svg>
